import type { ChapterAPIList, ChapterDetail, ChaptersInCourse, LimitOffsetSort } from '@jojotique/server'
import { fexios } from '@utils/fexios.ts'
import { getUrlWithPagination } from '@core/utils/url.ts'

interface LoadChaptersOptions {
  isComponents?: boolean
}

export const loadChapters = (pagination: LimitOffsetSort, opt?: LoadChaptersOptions): Promise<ChapterAPIList> => {
  return new Promise<ChapterAPIList>((resolve, reject) => {
    fexios
      .get<ChapterAPIList>(
        getUrlWithPagination('/api/chapters', pagination, { isComponents: opt?.isComponents }).toString(),
      )
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors du chargement des chapitres')
      })
      .catch((error) => {
        reject(`Erreur lors du chargement des chapitres: ${error}`)
      })
  })
}

export const loadCourseChapters = (courseSlug: string): Promise<ChaptersInCourse[]> => {
  return new Promise<ChaptersInCourse[]>((resolve, reject) => {
    fexios
      .get<ChaptersInCourse[]>(`/api/courses/${courseSlug}/chapters`)
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors du chargement des chapitres du cours')
      })
      .catch((error) => {
        reject(`Erreur lors du chargement des chapitres du cours: ${error}`)
      })
  })
}

export const loadChapterWithSlug = (chapterSlug: string): Promise<ChapterDetail> => {
  return new Promise<ChapterDetail>((resolve, reject) => {
    fexios
      .get<ChapterDetail>(`/api/chapters/${chapterSlug}`)
      .then((response) => {
        if (response.ok) {
          resolve(response.data)
          return
        }

        reject(response.data.message ?? 'Erreur inconnue lors du chargement du chapitre')
      })
      .catch((error) => {
        reject(`Erreur lors du chargement du chapitre: ${error}`)
      })
  })
}
